/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_General_Settings_LabelInputs */



/**
* | output |
* | --- |
* | "General Settings" |
*
* @param {Style_Guide_Manager_General_Settings_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_general_settings_label = /** @type {((inputs?: Style_Guide_Manager_General_Settings_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_General_Settings_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parametres generaux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Allgemeine Einstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni generali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Общие настройки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración general")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("常规设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一般設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामान्य सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações gerais")
	return /** @type {LocalizedString} */ ("General Settings")
});